import { gql } from "@apollo/client";

export const DELETE_CASE_NOTE_MUTATION = gql`
  mutation DeleteNote($noteId: String!, $organizationId: String!) {
    deleteNote(noteId: $noteId, organizationId: $organizationId)
  }
`;
